import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

interface CountSkeletonProps {
  className?: string;
  size?: 'sm' | 'md';
}

/**
 * A lightweight skeleton component specifically for count badges in sidebar buttons
 */
const CountSkeleton: React.FC<CountSkeletonProps> = ({
  className,
  size = 'sm'
}) => {
  return (
    <Skeleton 
      className={cn(
        "ml-auto rounded-full",
        size === 'sm' ? 'w-5 h-5' : 'w-6 h-6',
        className
      )}
    />
  );
};

export default CountSkeleton;
